<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 12 12"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    aria-hidden="true"
  >
    <line
      x1="2"
      y1="6"
      x2="10"
      y2="6"
    />
  </svg>
</template>

<script>
export default {
  name: "MinusIcon",
  props: {
    size: { type: Number, default: 12 },
  },
};
</script>
